export const PLATFORM_MATOMO_EVENT_CATEGORY_LEGAL = 'Legal';
export const PLATFORM_MATOMO_EVENT_CATEGORY_LINKS = 'Links';
export const PLATFORM_MATOMO_EVENT_CATEGORY_FOOTER = 'Footer';
